import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { system } from 'styled-system';

import sx from '../../internal/styles/sx';
import Box from '../Box';
import type { FlexProps } from './types';

export const BaseFlex = styled(Box, {
  shouldForwardProp,
})(
  {
    display: 'flex',
  },
  system({
    gap: {
      property: 'gap',
      scale: 'space',
    },
    rowGap: {
      property: 'rowGap',
      scale: 'space',
    },
    columnGap: {
      property: 'columnGap',
      scale: 'space',
    },
  }),
  sx
);

const Flex = styled(BaseFlex)<FlexProps>(({ display }) => ({
  display: display === 'inline-flex' ? display : 'flex',
}));

export default Flex;
